export class UserModel {
  public id: string;
  public firstName: string;
  public lastName: string;
  public street: string;
  public streetNumber: string;
  public postalCode: string;
  public city: string;
  public country: string = 'de';
  public phone: string;
  /**
   * Used in forms, before being saved to the actual user
   */
  public creditName: string;
  public email: string;
  public emailRepeat: string;
  public password: string;
  public passwordRepeat: string;
  public newsletter: string;

  public options = {
    displayName: 'anonymous',
    displayAmounts: 'yes'
  };

  public screenName: string;
  public token: string;

  public get shouldDisplayAmounts(): boolean {
    return this.options.displayAmounts !== 'no';
  }

  public get shouldDisplayName(): boolean {
    return this.options.displayName !== 'anonymous';
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/models/user.model.ts